export default {
  methods: {
    setClassModifiers (baseClass) {
      const classes = []

      const boolModifiers = [
        { value: this.right, stringName: 'right' },
        { value: this.left, stringName: 'left' },
        { value: this.right, stringName: 'right' },
        { value: this.small, stringName: 'small' },
        { value: this.vertical, stringName: 'vertical' },
        { value: this.simple, stringName: 'simple' },
        { value: this.isActive, stringName: 'active' },
        { value: this.active, stringName: 'active' },
        { value: this.flat, stringName: 'flat' },
        { value: this.clean, stringName: 'clean' },
        { value: this.success, stringName: 'success' },
        { value: this.error, stringName: 'error' },
        { value: this.light, stringName: 'light' },
        { value: this.outline, stringName: 'outline' },
        { value: this.inline, stringName: 'inline' },
        { value: this.rounded, stringName: 'rounded' },
        { value: this.noPadding, stringName: 'no-padding' },
        { value: this.noHeaderPadding, stringName: 'no-header-padding' },
        { value: this.noBackground, stringName: 'no-background' },
        { value: this.inactive, stringName: 'inactive' },
        { value: this.disabled, stringName: 'disabled' },
        { value: this.full, stringName: 'full' },
        { value: this.narrow, stringName: 'narrow' },
        { value: this.filled, stringName: 'filled' },
        { value: this.clickable, stringName: 'clickable' },
        { value: this.vertical, stringName: 'vertical' },

        { value: this.oneColumn, stringName: 'one-column' },
        { value: this.twoColumns, stringName: 'two-columns' },
        { value: this.threeColumns, stringName: 'three-columns' }
      ]

      const stringModifiers = [
        this.size,
        this.type,
        this.color,
        this.width,
        this.animation,
        this.theme,
        this.position,
        this.qualification
      ]

      stringModifiers.forEach(item => {
        if (item !== null && typeof item === 'string') {
          classes.push(baseClass + item.toLowerCase())
        }
      })

      boolModifiers.forEach(item => {
        if (typeof item.value === 'boolean' && item.value === true) {
          classes.push(baseClass + item.stringName.toLowerCase())
        }
      })

      return classes.join(' ')
    }
  }
}
